var isObjectURL = function (url) { return url.startsWith('blob'); };
var addLink = function (link) {
    var head = document.head || document.getElementsByTagName('head')[0] || document.body;
    var styleSheet = document.createElement('link');
    styleSheet.rel = 'stylesheet';
    styleSheet.href = link;
    head.appendChild(styleSheet);
};
export { addLink, isObjectURL };
//# sourceMappingURL=types.js.map